<template>
  <div class="ndi-view">
    <NavBar />
    <NavIsland />
    <main class="content-wrapper">
      <NDIComponent />
    </main>
  </div>
</template>

<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import NavBar from "@/component/common/NavBar.vue";
import NDIComponent from "@/component/project/NDIComponent.vue";
import NavIsland from "@/component/common/NavIsland.vue";

@Component({
  components: {
    NavBar,
    NavIsland,
    NDIComponent
  }
})
export default class NDIView extends Vue {}
</script>

<style scoped>
.ndi-view {
  min-height: calc(100vh - var(--ln-nav-offset));
  background-color: var(--ln-bg);
  /* padding-top: 80px; removed since App.vue handles global padding now */
}

.content-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
